<template>
  <div class="container">
    <app-header :title="$route.query.cname" />
    <van-search v-model="value" @click="$router.push('/search')"
                placeholder="请输入搜索关键词" />

    <!-- 分类 -->
    <!-- <div class="tabs row">
      <div class="tab"
           v-text="item.name"
           v-for="(item,index) in categoryList"
           :key="index"
           :class="[item.id==activeTag?'active':'']"
           @click="handleTag(item)"></div>
    </div> -->
    <!-- 推荐商品 -->
    <Goods :productList="productList" />

  </div>
</template>

<script>
import { getShopCategoryList } from '@/api/category'
import { getShopProductList,getShopCategoryProdList} from '@/api/product'
import Goods from './modules/Goods'
export default {
  name: "index",
  components: {
    Goods
  },
  data () {
    return {
      value: '',
      id: '',
      cid: '',
      activeTag: 0,
      categoryList: [],
      productList: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.id = vm.$route.query.id
      vm.pid = vm.$route.query.pid
      vm.activeTag = vm.id
      vm.getCategory()
      vm.getProduct(vm.id)
    })
  },
  beforeRouteLeave (to, from, next) {
    localStorage.setItem("scrollProduct", document.documentElement.scrollTop)
    next()
  },
  activated:function() {
    this.$nextTick(() => {
      document.documentElement.scrollTop = localStorage.getItem("scrollProduct")
      localStorage.setItem("scrollProduct", 0)
    })
  },
  created () {

  },
  methods: {
    getCategory () {
      getShopCategoryList({ pid: this.pid }).then(res => {
        if (res.success) {
          this.categoryList = res.data
        }
      })
    },
    getProduct (cid) {
      getShopProductList({ cid: cid }).then(res => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    onNavigate (url) {
      this.$router.push({
        path: url
      })
    },
    handleTag (item) {
      this.activeTag = item.id
      this.getProduct(item.id)
    }
  }
}
</script>

<style lang="less" scoped>
.container {

  .tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 44px;
    line-height: 44px;
    padding: 0 12px;
    overflow-x: scroll;
    -webkit-backface-visibility: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
    .tab {
      height: 25px;
      line-height: 25px;
      padding: 0 0.4rem;
      white-space: nowrap;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: #fe003b;
        border-bottom: 3px solid #fe003b;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/index.vue